const ChannelConfig = () =>
  import('@/views/main/helper/channelConfig/ChannelConfig.vue')
export default {
  path: '/main/helper/channelConfig',
  name: 'ChannelConfig',
  component: ChannelConfig,
  children: []
}
